import { render, staticRenderFns } from "./DynamicTable.vue?vue&type=template&id=1c27d488&scoped=true&"
import script from "./DynamicTable.vue?vue&type=script&lang=js&"
export * from "./DynamicTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c27d488",
  null
  
)

export default component.exports